import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import moment from "moment-timezone";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Container, Breadcrumb } from '@themesberg/react-bootstrap';
import { BannerHeading, BannerContainer, CourseCard, CourseImage, CourseTitle, CourseDates, CourseDescription } from "../components/services/ServicesElements";
import Image3 from "../images/courses.svg";
import InfoSectionLight from "../components/coursesSection";
import { BASE_URL } from '../constants';
const CoursesScreen = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
        try {
            const response = await fetch(`${BASE_URL}/course`);
            const data = await response.json();
            setCourses(data);
        } catch (error) {
            console.error('Error fetching courses:', error);
        }
    };

    fetchCourses();
  }, []);

  const handleCourseClick = (id) => {
    navigate(`/courses/${id}`); 
  };

  return (
    <Layout>
      <Container className="py-4 px-0"> 
        <Row className="justify-content-center"> 
          <InfoSectionLight
            image={Image3}
            id="#"
            title="Online Courses"
            text="Welcome to our online language courses designed specifically for refugees. Our courses aim to provide essential language skills that can help you integrate smoothly into your new community and improve your quality of life. Whether you're looking to learn English, the local language, or specific language skills for job applications and interviews, we have a course tailored to meet your needs. Our experienced instructors and interactive materials make learning both effective and enjoyable. Join us today and take the first step towards mastering the language skills that will open doors to new opportunities and help you connect with those around you."      
          />
        </Row>

        <BannerContainer>
  <BannerHeading>Language Courses</BannerHeading>
  {courses.length > 0 ? (
  <Row xs={1} sm={2} md={3} lg={4} xl={4} className="g-4 justify-content-center">
 
      {courses.map((course) => (
        <Col key={course._id} className="d-flex justify-content-center">
          <CourseCard 
            className="course-card p-3 border rounded-3 d-flex flex-column h-100"
            onClick={() => handleCourseClick(course._id)}
          >
            <CourseTitle>{course.name}</CourseTitle>
            <CourseDescription>{course.description}</CourseDescription>
            <CourseImage
              src={course.photo} 
              alt="Course" 
              className="img-fluid rounded-3 mb-2"  
              style={{ height: '200px', objectFit: 'cover' }} 
            />
            <CourseDates>
              <p><span>Start Date:</span> {moment(course.startDate).format('MMMM Do, YYYY')}</p>
              <p><span>End Date:</span> {moment(course.endDate).format('MMMM Do, YYYY')}</p>
            </CourseDates>
          </CourseCard>
        </Col>
      ))}
      </Row>
    ) : (
      <p className="text-center mt-4">No courses available at the moment. Please check back later.</p>
    )}

</BannerContainer>

      </Container>
    </Layout>
  );
};

export default CoursesScreen;
